<template>
    <div class="w-98 p-2">
        <div class="p-1">
            <div class="row">
                <div class="col-3">
                    <div class="janelaPequenaAdmin bg-pendencia janelaClickable" @click="irUsuarioPendente()">
                        <div class="col-12 tituloJanelaPequenaAdmin text-left">
                            <i class="fas fa-user-friends mr-1"></i> Usuários pendentes
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-grande fonte-pendencia">
                            <div class="mt-2" :class="(usuarioPendentes=='!?') ? 'dadoAltoOff': ''">
                                {{usuarioPendentes}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="janelaPequenaAdmin janelaClickable" @click="irEstrutura('gt')">
                        <div class="col-12 tituloJanelaPequenaAdmin text-left">
                            <i class="fas fa-boxes mr-1"></i> Grupos de Trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-grande mt-2" :class="(listaQntdEstrutura[0].qtd == '!?') ? 'dadoAltoOff': ''">
                            {{listaQntdEstrutura[0].qtd}}
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="janelaPequenaAdmin janelaClickable" @click="irEstrutura('coord')">
                        <div class="col-12 tituloJanelaPequenaAdmin text-left">
                            <i class="fas fa-boxes mr-1"></i> Coordenações
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-grande mt-2" :class="(listaQntdEstrutura[1].qtd == '!?') ? 'dadoAltoOff': ''">
                            {{listaQntdEstrutura[1].qtd}}
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="janelaPequenaAdmin janelaClickable" @click="irEstrutura('dpto')">
                        <div class="col-12 tituloJanelaPequenaAdmin text-left">
                            <i class="fas fa-boxes mr-1"></i> Departamentos
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-grande mt-2" :class="(listaQntdEstrutura[2].qtd == '!?') ? 'dadoAltoOff': ''">
                            {{listaQntdEstrutura[2].qtd}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-2">
            <div class="col-12">
                <div>
                    <!--
                    <div class="text-left ml-2">
                        <a href="/log">Log de Auditoria</a>
                    </div>
                    -->
                    <table class="table table-hover">
                        <thead>
                            <tr>
                                <th width="20%">Data/Hora</th>
                                <th width="40%">Ação</th>
                                <th width="40%">Funcionalidade</th>
                                <th width="40%">Usuário</th>
                            </tr>
                        </thead>
                        <tbody v-if="listaAuditoria.length > 0">
                            <tr v-for="log in listaAuditoria" :key="log.idlog">
                                <td>{{log.dataHoraFmt}}</td>
                                <td>{{log.acao}}</td>
                                <td>{{log.funcionalidade}}</td>
                                <td>{{log.usuario}}</td>
                            </tr>
                        </tbody>
                        <tbody class="dadoBaixoOff" v-if="listaAuditoria.length == 0">
                            <tr>
                                <td>31/12/2021 12:34:56</td>
                                <td>Ação de Log</td>
                                <td>Funcionalidade</td>
                                <td>Nome de Usuário Completo</td>
                            </tr>
                            <tr>
                                <td>31/12/2021 12:34:56</td>
                                <td>Ação de Log</td>
                                <td>Funcionalidade</td>
                                <td>Nome de Usuário Completo</td>
                            </tr>
                            <tr>
                                <td>31/12/2021 12:34:56</td>
                                <td>Ação de Log</td>
                                <td>Funcionalidade</td>
                                <td>Nome de Usuário Completo</td>
                            </tr>
                            <tr>
                                <td>31/12/2021 12:34:56</td>
                                <td>Ação de Log</td>
                                <td>Funcionalidade</td>
                                <td>Nome de Usuário Completo</td>
                            </tr>
                            <tr>
                                <td>31/12/2021 12:34:56</td>
                                <td>Ação de Log</td>
                                <td>Funcionalidade</td>
                                <td>Nome de Usuário Completo</td>
                            </tr>
                        </tbody>
                    </table>  
                    <div class="row">
                        <div class="col-10"></div>
                        <div style="margin-top: -10px;" @click="irMaisAuditoria()"
                                class="col-2 pr-5 tituloJanelaPequenaAdmin text-right clickable">
                            mais auditoria
                        </div>
                    </div>                                     
                </div>
            </div>
        </div>
        <div class="p-1" style="margin-top: -25px;">
            <div class=" text-center ml-2">
                Quantidade de usuários por GT
            </div>
            <div class="row" style="margin-top: 10px;">
                <div class="col-2 mt-2" v-for="qtd in listaQtdUsuariosGT" :key="qtd.nome">
                    <div class="quadroPequeno">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            {{qtd.nome}}
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media">
                            {{qtd.qtd}}
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="listaQtdUsuariosGT.length == 0">
                    <div class="quadroPequeno dadoBaixoOff">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            Quantidade de usuário por grupo de trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media dadoAltoOff">
                            !?
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="listaQtdUsuariosGT.length == 0">
                    <div class="quadroPequeno dadoBaixoOff">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            Quantidade de usuário por grupo de trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media dadoAltoOff">
                            !?
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="listaQtdUsuariosGT.length == 0">
                    <div class="quadroPequeno dadoBaixoOff">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            Quantidade de usuário por grupo de trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media dadoAltoOff">
                            !?
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="listaQtdUsuariosGT.length == 0">
                    <div class="quadroPequeno dadoBaixoOff">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            Quantidade de usuário por grupo de trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media dadoAltoOff">
                            !?
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="listaQtdUsuariosGT.length == 0">
                    <div class="quadroPequeno dadoBaixoOff">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            Quantidade de usuário por grupo de trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media dadoAltoOff">
                            !?
                        </div>
                    </div>
                </div>
                <div class="col-2" v-if="listaQtdUsuariosGT.length == 0">
                    <div class="quadroPequeno dadoBaixoOff">
                        <div class="col-12 tituloQuadroPequeno text-center">
                            Quantidade de usuário por grupo de trabalho
                        </div>
                        <div class="col-12 text-center font-weight-bold fonte-media dadoAltoOff">
                            !?
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Donuts from "./graficos/Donuts.vue";

export default {
    components: {
        Donuts
    },
    data() {
        return {
            // parte de cima
            usuarioPendentes: "!?",
            listaQntdEstrutura: [{
                qtd: "!?"
            },{
                qtd: "!?"
            },{
                qtd: "!?"
            }],

            // gráfico
            listaGrafico: [],
            datacollection: {},
            options: {
                responsive: true,
                maintainAspectRatio: false,
                hoverBorderWidth: 20,
            },

            listaAuditoria: [],

            // parte de baixo
            listaQtdUsuariosGT: [],
        };
    },
    created() {
        this.carregarTela();
    },
    methods: {
        carregarTela() {
            this.carregarUsuariosPendentes();
            this.carregarQuantidadeEstrutura();
            this.carregarGrafSituacaoProjeto();
            this.carregarListaAuditoria();
            this.carregarUsuariosGT();
        },
        carregarUsuariosPendentes() {
			this.$clubApi.get("/inicio/admin/usuarios/pendentes").then((response) => {
				this.usuarioPendentes = response.data.object;
			})
			.catch((error) => {
				this.$toastr.warning(error.response.data.msg);
			});
        },
        carregarQuantidadeEstrutura() {
			this.$clubApi.get("/inicio/admin/estrutura").then((response) => {
				this.listaQntdEstrutura = response.data.object;
			})
			.catch((error) => {
				this.$toastr.warning(error.response.data.msg);
			});
        },
        carregarGrafSituacaoProjeto() {

            this.datacollection = {
                labels: ['Não iniciados (12%)', 'Em andamento (52%)', 'Atrasados (5%)', 'Concluídos (17%)', 'Cancelados (2%)'],
                datasets: [{
                    borderWidth: 1,
                    backgroundColor: [
                        '#ccc',
                        '#65a1d1',
                        '#DD1B16',
                        '#28a745',
                        '#E46651',
                    ],
                    data: [10, 43, 25, 17, 21]
                }]
            };

			this.$clubApi.get("/inicio/admin/grafico/projeto").then((response) => {
				this.listaGrafico = response.data.object;
			})
			.catch((error) => {
				this.$toastr.warning(error.response.data.msg);
			});
        },
        carregarListaAuditoria() {
			this.$clubApi.get("/inicio/admin/log").then((response) => {
				this.listaAuditoria = response.data.object;
			})
			.catch((error) => {
				this.$toastr.warning(error.response.data.msg);
			});
        },
        carregarUsuariosGT() {
			this.$clubApi.get("/inicio/admin/usuarios/gt").then((response) => {
				this.listaQtdUsuariosGT = response.data.object;
			})
			.catch((error) => {
				this.$toastr.warning(error.response.data.msg);
			});
        },

        /*      LINKS       */
        irUsuarioPendente() {
            location.href = '/lead';
        },
        irEstrutura(estrutura) {
            location.href = '/estrutura#'+ estrutura;
        },
        irMaisAuditoria() {
            location.href = '/log';
        }
    }
};
</script>

<style>
.w-98 {
    width: 99%;
}
.bg-pendencia {
    background-color: #fdeef0;
}
.janelaPequenaAdmin {
    border: 1px solid white;
    border-bottom: 1px solid #ccc;
    border-right: 1px solid #ccc;
    box-shadow: 0 0 4px rgba(0,0,0,.125),0 2px 4px rgba(0,0,0,.2);
    border-radius: 5px;
    height: 90px;
}
.tituloJanelaPequenaAdmin {
    font-size: 11px;
}
.quadroPequeno {
    border: 1px solid #d4e5f3;
    background-color: #d0e3f3;
    border-radius: 4px;
    height: 90px;
}
.tituloQuadroPequeno {
    height: 45px;
    font-size: 11px;
}
.fonte-grande {
    font-size: 42px;
}
.fonte-media {
    font-size: 21px;
}
.fonte-pendencia {
    color: #dc3545
}
.grafico-pequeno {
    height: 300px;
}
.dadoBaixoOff {
    filter: blur(3px);
}
.dadoAltoOff {
    filter: blur(7px);
}
.janelaClickable {
	cursor: pointer !important;
}
.janelaClickable:hover {
	cursor: pointer !important;
    opacity: 70%;
    -khtml-opacity:.70; 
    -moz-opacity:.70; 
    -ms-filter:”alpha(opacity=70)”;
    filter:alpha(opacity=70);
    filter: progid:DXImageTransform.Microsoft.Alpha(opacity=0.7);
    opacity:.70;     
}
.clickable {
	cursor: pointer !important;
}
</style>
